export default __webpack_public_path__ + "static/media/c.faa67b97.png";